import { Component, OnInit, ViewChild, Input, AfterViewInit } from '@angular/core'
import { FormyService } from './formy.service'
import { GridService } from '../grid/grid.service'
import { PageService } from '../../page/page.service'
import { GridModel } from '../grid/grid.model'
import { NgForm } from '@angular/forms'

@Component({
  selector: 'app-formy',
  templateUrl: './formy.component.html',
  styleUrls: ['./formy.component.css'],
  providers: [FormyService]
})
export class FormyComponent implements OnInit, AfterViewInit {
  @Input() model: GridModel
  @Input() dyn: any
  @ViewChild('form') form: NgForm
  ctyp = 'formy'
  submitted = false

  constructor(private pservice: PageService, public service: FormyService, public gservice: GridService) {
    this.service.components.push(this)
  }

  ngOnInit() {
    this.pservice.components.grds.push(this)
    // if (this.model.dyn && this.model.dyn.iem) {
    //   this.model.iem = this.model.dyn.iem
    // }
    // this.model.cform = 2
    // this.row_i = 0
    // this.model.sta = 3
    //  this.gservice.add(null, this.model, 2)
    // if (this.model.iem)
    //   this.service.clear(this.model)
    // else
    //   this.service.load(this.model, this.model.dyn.row_id, this.model.dyn.grid_id)
    console.log(1112)
    // if(this.model.disf==2) this.gservice.add(null, this.model, 2)
  }

  ngAfterViewInit() {
    if(this.model.disf==2) this.gservice.init(this.model)
  }

  grd(siz: number) {
    return this.service.grd(siz)
  }

  trackByIdx(index: number, obj: any): any {
    return index;
  }
}
